import styled from 'styled-components';

export const ContainerTableNcmLote = styled.div`
  .table {
    margin-top: 10px;
    min-height: 320px;
  }
  .table .hideRightSeparator .MuiDataGrid-columnSeparator {
    display: none;
  }
`;
